import angular from "angular";
import { SettingsService } from "../../services";
import { InputEnumController } from "./InputEnumController";
import { EmployeeGroupDefinition } from "@salaxy/core";

/**
 * Controller for selecting an employee group.
 */

export class InputEmployeeGroupController extends InputEnumController {

  /**
   * For NG-dependency injection
   * @ignore
   */
  public static $inject = ["$scope", "SettingsService"];

  private employeeGroups: EmployeeGroupDefinition[] = [];

  /**
   * Creates a new InputOccupationTypeController
   * @ignore
   */
  constructor(private $scope: angular.IScope, private settingsService: SettingsService) {
    super();
  }

  /** Options list */
  public get options(): any[] {
    const newEmployeeGroups = this.settingsService.current?.calc?.employeeGroups || [];
    if (!angular.equals(this.employeeGroups, newEmployeeGroups)) {
      this._options = newEmployeeGroups.map( (x) => {
        return {
          value: x.id,
          text: x.name,
        };
      });
    }
    return this._options;
  }
  public set options(value: any[]) {
    // empty on purpose
    // this._options = value;
  }
}
